import { connect } from 'react-redux';
import Returns, {
  ReturnsProps,
} from '@/components/DeprecatedPortfolio/components/Returns';
import {
  portfolioSelector,
  portfolioSummarySelector,
  hasHoldingsInDifferentCurrencies,
} from '@/components/DeprecatedPortfolio/redux/selectors';
import { get } from 'lodash';

const getter = (obj) => (property, defaultValue) =>
  get(obj, property, defaultValue);

type StateProps = Omit<ReturnsProps, 'sectionNumber'>;
const makeMapStateToProps = () => {
  const mapStateToProps = (state): StateProps => {
    const portfolioSummary = portfolioSummarySelector(state);
    const portfolio = portfolioSelector(state);
    const summaryGetter = getter(portfolioSummary);
    /**
     * The lodash typing is acting weird. If it was inline it would
     * infer the return value of `get` is undefined.
     */
    const beta = get(portfolio, ['beta'], 0);
    const chartData = get(portfolio, ['chartData'], []);
    const currencyISO = get(portfolio, ['currencyISO'], '');
    const currencySymbol = get(portfolio, ['currencySymbol'], '');
    const holdings = get(portfolio, ['holdings'], undefined);
    const lastUpdated = get(portfolio, ['lastUpdatedmilliseconds'], 0);
    const portfolioId = get(portfolio, ['id'], '');
    const portfolioName = get(portfolio, ['name'], '');
    const secretCode = get(portfolio, ['secretCode'], undefined);
    return {
      beta,
      chartData,
      currencyISO,
      currencySymbol,
      holdings,
      lastUpdated,
      portfolioId,
      portfolioName,
      secretCode,
      isWatchlist: summaryGetter('isWatchlist', false),
      hasHoldingsInDifferentCurrencies: hasHoldingsInDifferentCurrencies(state),
    };
  };
  return mapStateToProps;
};

type ContainerProps = Pick<ReturnsProps, 'sectionNumber'>;
export default connect<StateProps, undefined, ContainerProps>(
  makeMapStateToProps
)(Returns);
